/**
 * Identificação desta página, mandada em `X-Client-Id` a cada requisição.
 *
 * O aviso de cadastro alterado (FEAT-044) vai para o terreiro inteiro, e volta
 * também para quem fez a alteração. Quem fez já recarregou pelo aviso local
 * (`useEntityRefresh`): com este id a página reconhece o próprio eco e não lê a
 * lista duas vezes.
 *
 * Fica só em MEMÓRIA, de propósito. A primeira versão guardava no
 * `sessionStorage` para sobreviver ao F5, e o Codex mostrou o furo: duplicar a
 * aba (ou abrir com `window.open`) COPIA o `sessionStorage`, as duas abas ficam
 * com o mesmo id e passam a descartar as alterações uma da outra — falha
 * silenciosa, a tela simplesmente não atualiza. Em memória, cada carregamento
 * de página tem o seu, e perder o id no F5 não custa nada: a página recarrega
 * os dados no mount de qualquer forma.
 */
let current: string | null = null;

function newId(): string {
	// `randomUUID` não existe em contexto sem HTTPS (http://ip:porta na rede do
	// terreiro) — o id só precisa ser único entre páginas, não criptográfico.
	if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
		return crypto.randomUUID();
	}
	return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getClientId(): string {
	if (!current) current = newId();
	return current;
}
